import * as React from 'react';
import { SetupOrgOnboardingSteps } from '@sdk/authentication/types';
import useAuth from '@sdk/authentication/useAuth';

import {
  ColumnsContainer,
  Container,
  LeftColumn,
  RightColumn,
  StepContent,
  StepContentPadding,
} from '@web/onboarding/styles';
import FullPageContainer from '@web/components/FullPageContainer';
import TopNavbar, { TOP_NAVBAR_HEIGHT } from '@web/components/TopNavbar';
import { NumberedSteps } from '@web/onboarding/steps/components/NumberedSteps';
import OnboardingBackground from '@web/onboarding/components/OnboardingBackground';

type Props = {
  children: React.ReactNode;
  activeStep: SetupOrgOnboardingSteps;
  steps: SetupOrgOnboardingSteps[];
};

export const NumberedStepsWrapper = ({ steps, activeStep, children }: Props) => {
  const { currentUser } = useAuth();

  return (
    <FullPageContainer>
      <Container>
        <TopNavbar />
        <ColumnsContainer>
          <LeftColumn>
            <NumberedSteps activeStep={activeStep} steps={steps} />
          </LeftColumn>
          <RightColumn topSpacing={TOP_NAVBAR_HEIGHT}>
            <StepContentPadding />
            <StepContent>{children}</StepContent>
            <StepContentPadding />
            <OnboardingBackground step={activeStep} industry={currentUser.org?.businessCategory} />
          </RightColumn>
        </ColumnsContainer>
      </Container>
    </FullPageContainer>
  );
};
